import React, { useState, useEffect } from 'react';
import { IoEyeOutline } from 'react-icons/io5';
import { FaRegEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthData } from '../Redux/AuthSlice';
import { InfinitySpin } from 'react-loader-spinner';
import { api_url } from '../config';
import { toast } from 'react-toastify';
import { IoArrowBackCircleOutline } from "react-icons/io5";

const admin_url = process.env.REACT_APP_ADMIN_URL;

const LoginForm = ({ activeTab, setActiveTab }) => {
    // const [activeTab, setActiveTab] = useState('wholesale');
    const switchTab = (tab) => {
        setActiveTab(tab);
    };
    const navigate = useNavigate();
    const [wholesale_username, setWholesale_username] = useState('');
    const [wholesale_password, setWholesale_password] = useState('');
    const [retail_username, setRetail_username] = useState('');
    const [retail_password, setRetail_password] = useState('');
    const [passwordState, setPasswordState] = useState(false);
    const [loading, setLoading] = useState(false);
    const [wholesaleError, setWholesaleError] = useState(null)
    const [retailError, setRetailError] = useState(null)

    const handlePasswordToggle = (e) => {
        e.preventDefault();
        setPasswordState(!passwordState);
    };
    const dispatch = useDispatch()

    const handleWholesaleLogin = async (e) => {
        e.preventDefault();
        const loginForm = {
            username: wholesale_username,
            password: wholesale_password
        }
        try {
            setLoading(true);
            const response = await axios.post(api_url + '/api/wholesaler/login', loginForm, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            // console.log(response.data);
            toast.success('Login Successful')
            dispatch(setAuthData(response.data))
            // dispatch(setRoles(response.data.roles))
            navigate('/wholesale/summary')

        } catch (error) {
            setWholesaleError(error?.response?.data?.error)
            //console.log(error?.response?.data?.error);
        } finally {
            setLoading(false);
        }
    }


    const handleRetailLogin = async (e) => {
        e.preventDefault();
        const loginForm = {
            username: retail_username,
            password: retail_password
        }
        try {
            setLoading(true);
            console.log('Making API call to:', api_url + '/api/retailer/login');
            const response = await axios.post(api_url + '/api/retailer/login', loginForm, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            toast.success('Login Successful')
            dispatch(setAuthData(response.data))
            navigate('/retail/summary')
        } catch (error) {
            setRetailError(error?.response?.data?.error)
            toast.error(error?.response?.data?.error)

        } finally {
            setLoading(false);
        }
    }
    const auth = useSelector((state) => state.auth)


    return (
        <div className=' shadow mx-6 md:mr-[10em] max-w-[32em] '>
            <section >

                {/* {activeTab == 'wholesale' ? <div className='flex items-center justify-center m-4'>
                    <img src={wlogo} className='w-[100px]  rounded-md shadow-lg' />
                </div> : <div className='flex items-center justify-center m-4'>
                    <img src={rlogo} className='w-[100px]  rounded-md shadow-lg' />
                </div>} */}

                <div className='flex justify-center '>
                    <div className='sm:w-[55vw] xl:w-[35vw] rounded-3xl sm:rounded-3xl sm:shadow bg-white px-4 md:px-6  '>
                        <div className='p-6 relative'>
                            <Link to='/' className='absolute md:top-12 md:left-0 -top-8 -left-2 flex items-center'>
                                <IoArrowBackCircleOutline size={28} className='text-white md:text-black' />
                                <p className='block md:hidden text-sm text-white'>Back</p>
                            </Link>
                            <h1 className='text-2xl md:text-3xl my-4 text-center font-bold'>Welcome Back</h1>
                            <p className='-mt-4 text-center text-sm  font-semibold'>
                                {activeTab === 'admin' ? 'Sign in to manage your operations as an admin.' : 'Sign in to manage your operations as a wholesale pharmacy or wholesale partner.'}
                            </p>
                        </div>

                        <div className='flex font-lufga gap-4 mx-4 justify-center my-5'>
                            <button
                                className={`text-xs sm:text-sm cursor-pointer py-2 px-4 transition-all duration-300 linear border-b-2 ${activeTab === 'wholesale'
                                    ? 'border-blue-500 text-blue-500'
                                    : 'border-transparent'
                                    }`}
                                onClick={() => switchTab('wholesale')}
                            >
                                Wholesale
                            </button>
                            <button
                                className={`text-xs sm:text-sm cursor-pointer py-2 px-4 transition-all duration-300 linear border-b-2 ${activeTab === 'retail'
                                    ? 'border-green-500 text-green-500'
                                    : 'border-transparent'
                                    }`}
                                onClick={() => switchTab('retail')}
                            >
                                Retail
                            </button>
                            <button
                                className={`text-xs sm:text-sm cursor-pointer py-2 px-4 transition-all duration-300 linear border-b-2 ${activeTab === 'admin'
                                    ? 'border-purple-500 text-purple-500'
                                    : 'border-transparent'
                                    }`}
                                onClick={() => switchTab('admin')}
                            >
                                Admin
                            </button>
                        </div>
                        {activeTab === 'wholesale' ? (
                            <div className=' space-y-4 md:space-y-6 '>
                                <form className='space-y-4 md:space-y-6' >
                                    {wholesaleError && (
                                        <div>
                                            <p className="bg-red-300 font-lufga rounded-md shadow-md px-2 py-1 text-sm ">
                                                {typeof wholesaleError === 'string' ? wholesaleError : (
                                                    Object.keys(wholesaleError).map((key) => (
                                                        Array.isArray(wholesaleError[key]) ? wholesaleError[key][0] : wholesaleError[key]
                                                    ))
                                                )}
                                            </p>
                                        </div>
                                    )}
                                    <div>
                                        <label

                                            className='block font-lufga mb-2 text-sm font-medium text-gray-900 '
                                        >
                                            Username
                                        </label>
                                        <input
                                            value={wholesale_username}
                                            onChange={(e) => setWholesale_username(e.target.value)}
                                            type='username'
                                            name='username'
                                            id='username'
                                            className='bg-[#EBEBEB]  border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none  block w-full p-2.5 '
                                            placeholder='wholesaleuser'
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor='password'
                                            className='block mb-2 font-lufga text-sm font-medium text-gray-900 '
                                        >
                                            Password
                                        </label>
                                        <div className='flex justify-between items-center bg-[#EBEBEB] border text-xs border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600  w-full p-2.5'>
                                            <input
                                                value={wholesale_password}
                                                onChange={(e) => setWholesale_password(e.target.value)}
                                                type={passwordState ? 'text' : 'password'}
                                                name='password'
                                                placeholder='••••••••'
                                                className='bg-[#EBEBEB] focus:outline-none w-full'
                                                required
                                            />
                                            {passwordState ? (
                                                <IoEyeOutline size={20} onClick={handlePasswordToggle} />
                                            ) : (
                                                <FaRegEyeSlash size={20} onClick={handlePasswordToggle} />
                                            )}
                                        </div>
                                    </div>
                                    <div className='pt-8 pb-4'>
                                        <button
                                            onClick={handleWholesaleLogin}
                                            className='w-full font-lufga  text-white bg-gradient-to-r from-[#18487F] to-[#27C4F4] focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-full text-sm px-5 py-2.5 text-center '
                                        >

                                            Sign in
                                        </button>
                                    </div>

                                    {loading ? (<div className="flex justify-center items-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm absolute top-0 left-0">
                                        <InfinitySpin color="#387ADF" loading={loading} size={32} />
                                    </div>) : null}
                                    {/* <div className='flex justify-between items-center font-lufga'>
                                        <Link to='/forgot-wholesale-pass'>
                                            <p className='hover:underline cursor-pointer text-sm text-blue-800'>Forgot Password?</p>
                                        </Link>
                                        <Link to='/signup'>
                                            <p className='hover:underline cursor-pointer text-sm text-blue-800'> Setup Account</p>
                                        </Link>
                                    </div> */}
                                    <p className='text-center text-sm'>Don't have an account? Let's <Link to={`${process.env.REACT_APP_ADMIN_URL.replace(/\/?$/, '')}/signup`} className='text-blue-500' target="_blank" rel="noopener noreferrer">Set Up account</Link> to get started.</p>
                                    <p className='text-gray-800  flex justify-center pb-6 text-sm'>Privacy Policy <span className='self-center '>. </span>Terms</p>
                                </form>
                            </div>
                        ) : activeTab === 'retail' ? (
                            <div className='space-y-4 md:space-y-6 '>
                                <form className='space-y-4 md:space-y-6' >
                                    {retailError && (
                                        <div>
                                            <p className="bg-red-300 font-lufga rounded-md shadow-md px-2 py-1 text-sm ">
                                                {typeof retailError === 'string' ? retailError : (
                                                    Object.keys(retailError).map((key) => (
                                                        Array.isArray(retailError[key]) ? retailError[key][0] : retailError[key]
                                                    ))
                                                )}
                                            </p>
                                        </div>
                                    )}
                                    <div>
                                        <label
                                            htmlFor='username'
                                            className='block mb-2 font-lufga text-sm font-medium text-gray-900 '
                                        >
                                            Username
                                        </label>
                                        <input
                                            value={retail_username}
                                            onChange={(e) => setRetail_username(e.target.value)}
                                            type='username'
                                            name='username'
                                            id='username'
                                            className='bg-gray-50 border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none  block w-full p-2.5 '
                                            placeholder='retailuser'
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor='password'
                                            className='block font-lufga mb-2 text-sm font-medium text-gray-900 '
                                        >
                                            Password
                                        </label>
                                        <div className='flex justify-between items-center bg-gray-50 border text-xs border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600  w-full p-2.5'>
                                            <input
                                                value={retail_password}
                                                onChange={(e) => setRetail_password(e.target.value)}
                                                type={passwordState ? 'text' : 'password'}
                                                name='password'
                                                placeholder='••••••••'
                                                className='bg-gray-50 focus:outline-none w-full'
                                                required
                                            />
                                            {passwordState ? (
                                                <IoEyeOutline size={20} onClick={handlePasswordToggle} />
                                            ) : (
                                                <FaRegEyeSlash size={20} onClick={handlePasswordToggle} />
                                            )}
                                        </div>
                                    </div>
                                    <div className='pt-8 pb-4'>
                                        <button
                                            onClick={handleRetailLogin}
                                            className='w-full  font-lufga text-white bg-gradient-to-r from-[#4CD964] to-[#137044]  focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center '
                                        >
                                            Sign in
                                        </button>
                                    </div>

                                    {loading ? (<div className="flex justify-center items-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm absolute top-0 left-0">
                                        <InfinitySpin color="#9BCF53" loading={loading} size={32} />
                                    </div>) : null}
                                    {/* <div className='flex justify-between font-lufga'>
                                        <Link to='/forgot-retail-pass'>
                                            <p className='hover:underline cursor-pointer text-sm text-blue-800'>Forgot Password?</p>
                                        </Link>
                                        <Link to='/signup'>
                                            <p className='hover:underline cursor-pointer text-sm text-blue-800'> Setup Account</p>
                                        </Link>
                                    </div> */}
                                    <p className='text-center  text-sm'>Don't have an account? Let's <Link to={process.env.REACT_APP_CREATE_ACCOUNT_URL} className='text-green-500'>Set Up account</Link> to get started.</p>
                                    <p className='text-gray-800  flex justify-center pb-6  text-sm'>Privacy Policy <span className='self-center '>. </span>Terms</p>
                                </form>
                            </div>
                        ) : (
                            <div className='flex flex-col items-center space-y-6 py-10'>
                                <button
                                    onClick={() => {
                                        setActiveTab('wholesale');
                                        window.open(`${admin_url}?type=wholesale`, '_blank');
                                    }}
                                    className='w-full md:w-2/3 text-white bg-gradient-to-r from-blue-700 to-blue-400 hover:from-blue-800 hover:to-blue-500 font-lufga font-bold rounded-full text-lg px-5 py-3 text-center transition-all duration-300 shadow-lg hover:shadow-xl'
                                >
                                    Wholesale Admin
                                </button>
                                <button
                                    onClick={() => {
                                        setActiveTab('retail');
                                        window.open(`${admin_url}?type=retail`, '_blank');
                                    }}
                                    className='w-full md:w-2/3 text-white bg-gradient-to-r from-green-600 to-green-400 hover:from-green-700 hover:to-green-500 font-lufga font-bold rounded-full text-lg px-5 py-3 text-center transition-all duration-300 shadow-lg hover:shadow-xl'
                                >
                                    Retail Admin
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LoginForm;
